import React from 'react';

export default function RingkasanKategoriKarat({ selectedItems }) {
  if (!selectedItems || selectedItems.length === 0) return null;

  const summary = selectedItems.reduce((acc, item) => {
    const kategori = item?.jenis_kategori?.kategori?.nama_kategori || 'Tanpa Kategori';
    const karat = item?.karat ? `${item.karat} Karat` : 'Tanpa Karat';
    const berat = parseFloat(item?.berat) || 0;

    if (!acc[kategori]) {
      acc[kategori] = {
        totalPcs: 0,
        totalBerat: 0,
        karats: {},
      };
    }

    acc[kategori].totalPcs += 1;
    acc[kategori].totalBerat += berat;

    if (!acc[kategori].karats[karat]) {
      acc[kategori].karats[karat] = { pcs: 0, berat: 0 };
    }

    acc[kategori].karats[karat].pcs += 1;
    acc[kategori].karats[karat].berat += berat;

    return acc;
  }, {});

  const formatBerat = (berat) => {
    return Number(berat || 0).toFixed(3);
  };

  return (
    <div className="bg-amber-50/40 dark:bg-amber-900/10 border border-amber-200/60 dark:border-amber-800/50 rounded-md p-4 mb-4">
      <h3 className="text-[13px] font-bold text-amber-800 dark:text-amber-500 uppercase tracking-wide">
        Ringkasan Item Berdasarkan Kategori & Karat
      </h3>

      <div className="mt-3 flex flex-col gap-3">
        {Object.entries(summary).map(([kategori, data], idx) => (
          <div key={idx} className="bg-white dark:bg-slate-800 border border-amber-100 dark:border-amber-900/50 rounded-lg p-3.5 shadow-sm">
            <div className="flex items-center justify-between border-b border-slate-100 dark:border-slate-700/50 pb-2.5 mb-2.5">
              <h4 className="font-bold text-slate-800 dark:text-slate-100 text-[15px]">{kategori}</h4>
              <span className="bg-amber-100 dark:bg-amber-900/40 text-amber-800 dark:text-amber-400 font-semibold px-2.5 py-1 rounded-md text-[13px]">
                {data.totalPcs} PCS ({formatBerat(data.totalBerat)} gr)
              </span>
            </div>
            
            <div className="flex flex-wrap gap-2.5">
              {Object.entries(data.karats).map(([karat, kData], kIdx) => (
                <div key={kIdx} className="bg-slate-50 dark:bg-slate-900/50 border border-slate-200 dark:border-slate-700 rounded-md px-3 py-2 flex items-center justify-between min-w-[160px] flex-1 sm:flex-none">
                  <span className="text-slate-500 dark:text-slate-400 text-sm font-medium mr-4">{karat}</span>
                  <span className="font-bold text-slate-800 dark:text-slate-200 text-sm">
                    {kData.pcs} PCS / {formatBerat(kData.berat)} gr
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
